import React from 'react'
import CardTooltip from './CardTooltip'

const Tag = ({ variant, text, tooltip }) => {
  const type = {
    "primary": "bg-web-blue text-white",
    "secondary": "bg-[#C4E0F2]",
    "success": "bg-success text-successDark font-medium",
    "danger": "bg-error text-errorDark",
    "warning": "bg-warning text-warningDark",
    "secondary-dark": "bg-[#9CA3AF] text-white",
    "info": "bg-info text-white",
    "light": "bg-light text-dark",
    "dark": "bg-dark text-white",
    "gradientBlue": "bg-gradient-to-r from-[#00BCC4] to-[#0079E9] text-white font-bold px-3 !rounded-full",
    "default": "bg-[#F0F0F0] text-[#444D63] font-medium",
    "gray": "bg-[#D9D9D9] border border-[#8C8C8C] text-gray-600 font-bold",
  }
  return (
    <CardTooltip tooltip={tooltip} position='left' className={tooltip && "rounded-md px-1 py-1 h-fit w-fit text-xs bg-slate-50"}>
      <div className={`${type[variant]} rounded-md px-1 py-1 h-fit w-fit text-xs cursor-default`}>{text}</div>
    </CardTooltip>
  )
}

export default Tag